const cystatinC = {
  parameters: [
    {
      name: 'cystatinC-female',
      displayName: 'Cystatin C',
      id: 'cystatinC',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'deficiency', 'high', 'fault'],
      criteria: {
        sexe: ['female'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#6f6b72',
          description: 'cystatinC-female-deficiency',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 0.59,
          upperLimitOperator: '<',
          unit: 'mg/l',
          interpretation: 'deficiency',
          treatAs: 'normal',
          displayInterpretation: 'Deficiency',
          rangeInterpretation: '0 - 0.58',
        },
        {
          color: '#1f7359',
          description: 'cystatinC-female-normal',
          lowerLimit: 0.59,
          lowerLimitOperator: '>=',
          upperLimit: 0.98,
          upperLimitOperator: '<=',
          unit: 'mg/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '0.59 - 0.98',
        },
        {
          color: '#f52d0a',
          description: 'cystatinC-female-high',
          lowerLimit: 0.98,
          lowerLimitOperator: '>',
          upperLimit: 5,
          upperLimitOperator: '',
          unit: 'mg/l',
          interpretation: 'high',
          displayInterpretation: 'High',
          rangeInterpretation: '> 0.98',
        },
      ],
    },
    {
      name: 'cystatinC-male',
      displayName: 'Cystatin C',
      id: 'cystatinC',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'deficiency', 'high', 'fault'],
      criteria: {
        sexe: ['male'],
        age: {
          min: 5,
          max: 110,
        },
      },
      ranges: [
        {
          color: '#6f6b72',
          description: 'cystatinC-male-deficiency',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 0.68,
          upperLimitOperator: '<',
          unit: 'mg/l',
          interpretation: 'deficiency',
          treatAs: 'normal',
          displayInterpretation: 'Deficiency',
          rangeInterpretation: '0 - 0.67',
        },
        {
          color: '#1f7359',
          description: 'cystatinC-male-normal',
          lowerLimit: 0.68,
          lowerLimitOperator: '>=',
          upperLimit: 1.22,
          upperLimitOperator: '<=',
          unit: 'mg/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
          rangeInterpretation: '0.68 - 1.22',
        },
        {
          color: '#f52d0a',
          description: 'cystatinC-male-high',
          lowerLimit: 1.22,
          lowerLimitOperator: '>',
          upperLimit: 5,
          upperLimitOperator: '',
          unit: 'mg/l',
          interpretation: 'high',
          displayInterpretation: 'High',
          rangeInterpretation: '> 1.22',
        },
      ],
    },
  ],
};

export default cystatinC;
